// src/components/Header.tsx
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';
import { useSettings } from '../context/SettingsContext';
import { useSpring, animated } from 'react-spring';
import { useInView } from 'react-intersection-observer';
// import { Tables, CartPageProps } from '../utils/types'; // Adjust based on your setup
import { HiDocumentReport } from "react-icons/hi";
import { IoLogOut, IoSettings, IoClose, IoMenu } from "react-icons/io5";
import { useOrderType } from '../hooks/useOrderType';
import { useAuth } from '../context/AuthContext'; // Import the useAuth hook
// import { CartItem, OrderItem, Tables, CartPageProps } from '../utils/types'; // Adjust based on your setup
import { useCart } from '../context/CartContext'; // Import the cart context
import { Tables } from '../utils/types'; // Adjust based on your setup


// const Header: React.FC<CartPageProps> = ({ setOrderTypeModalOpen }) => {
const Header: React.FC<{ setOrderTypeModalOpen: (open: boolean) => void }> = ({ setOrderTypeModalOpen }) => {
    const { settings } = useSettings();
    const { logout } = useAuth();
    const [orderId, setOrderId] = useState<number | null>(null);

    const { orderType, updateOrderType } = useOrderType();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [ref, inView] = useInView({ threshold: 0.1 });

    const location = useLocation(); // Get current route

    const navigate = useNavigate(); // Navigate between pages

    const props = useSpring({
        transform: inView ? 'scale(1)' : 'scale(0.9)',
        config: { tension: 300, friction: 20 },
    });

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    let currSelectedTable = localStorage.getItem('currSelectedTable') || null;
    // currSelectedTable = currSelectedTable?.replace(/"([^"]+)":/g, '$1:') || null;

    // Handle order type selection
    const handleOrderTypeChange = (type: 'Dine In' | 'Takeaway') => {
        handleNewSession(); // Clear cart and session data
        updateOrderType(type);
        if (type === 'Dine In') {
            navigate('/tables'); // Navigate to Table selection
        } else {
            navigate('/'); // Navigate to root for Takeaway
        }
    };

    // console.log('stb>', currSelectedTable);

        const { clearCart, setCartItems } = useCart();

    const [selectedTable, setSelectedTable] = useState<Tables | null>(null);
    
    const handleNewSession = () => {
        clearCart();
        // Clear relevant session data
        localStorage.removeItem('existingOrderId');
        localStorage.removeItem('checkedOutItems');
        localStorage.removeItem('selectedTable');
        localStorage.removeItem('orderId');

        // Explicitly reset state to ensure no leftover values
        setOrderId(null);  // Assuming `orderId` is a state variable
        setCartItems([]);   // Clear the cart

        // Optionally reset any other relevant states
        setSelectedTable(null);
        updateOrderType('');

        navigate('/'); // Redirect to a page (home or otherwise) to refresh the session
    };

    return (
        <header className="fixed top-0 z-40 w-full ">
            <div className='w-full  h-12 flex  flex-row md:flex-row justify-start  bg-white shadow-xl text-blue-600'>

                <div className="w-3/5 flex flex-row">
                    
                    <img
                        src={'../images/df.png'}
                        alt={settings?.officeName}
                        crossOrigin="anonymous"
                        className='w-12 p-0 m-0'
                        onClick={() => navigate('/')}
                    />

                    <div className='w-full'>
                        <h3 className=" h-1/2 text-sm md:text-xl font-bold mr-1 mt-3 mb-0 p-0" style={{ color: '#7a75b5' }}>
                            <Link to="/" className="mr-2">{settings?.officeName}</Link>
                        </h3>
                    </div>

                    {isAuthenticated() && location.pathname !== '/login' && (
                        <div className="font-normal mb-0 flex flex-row text-xs">
                            <span className="m-0 p-0 mr-2 text-red-500">
                                {localStorage.getItem('orderId') && localStorage.getItem('orderId') !== 'null' ? (
                                    <span onClick={() => navigate(`/order-details/${localStorage.getItem('orderId')}`)} className='cursor-pointer underline underline-offset-4'>
                                        #{localStorage.getItem('orderId')}
                                    </span>
                                ) : (
                                    <>New Order</>
                                )}


                                {/* Table Selection - Visible Only for Dine In */}
                                {orderType === 'Dine In' && (
                                    <span onClick={() => navigate('/tables')} className="m-0 p-0">
                                        <br /><span className='font-bold text-purple-700'>TB:&nbsp;{currSelectedTable || 'None'}</span>
                                        {/* Include logic to open table selection modal if needed */}
                                    </span>
                                )}

                                {orderType === 'Takeaway' && (
                                    <span onClick={() => navigate('/')} className="m-0 p-0">
                                        <br /><span className='font-bold text-purple-700'>Takeaway</span>
                                        {/* Include logic to open table selection modal if needed */}
                                    </span>
                                )}

                            </span>



                        </div>
                    )}

                </div>

                <div className='w-2/5 flex flex-row justify-between'> {/* Add items-center here */}

                    {/* Conditionally render orderType button */}
                    {isAuthenticated() && location.pathname !== '/login' && (
                        <div className="w-full h-2/3 flex flex-row space-x-2">
                            <div
                                onClick={() => handleOrderTypeChange('Dine In')}
                                className={`w-full  text-white py-1 text-sm text-center rounded-b-lg shadow-xl cursor-pointer ${orderType === 'Dine In' ? 'grayscale-0' : 'grayscale'
                                    }`}
                                
                                style={{ backgroundColor: '#7a75b5' }}
                            >
                                Dine In
                            </div>
                            <div
                                onClick={() => handleOrderTypeChange('Takeaway')}
                                className={`w-full  text-white py-1 text-sm text-center rounded-b-lg shadow-xl cursor-pointer ${orderType === 'Takeaway' ? 'grayscale-0' : 'grayscale'
                                    }`}
                                style={{ backgroundColor: '#7a75b5' }}
                            >
                                Takeaway
                            </div>
                        </div>
                    )}


                </div>

            </div>
        </header>
    );
};


export default Header;
